module.exports = __webpack_public_path__ + "img/yujianchao.e1c5f5ca.jpg";